import { Typography } from '@shipengine/giger';
import { useTranslation } from '@packlink/translation-provider';
import { getTrackingCurrentStatusStyles } from './TrackingCurrentStatusStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { getTrackingStatusLabelKey, getTrackingStatusDescriptionKey } from '../../../utils/TrackingStatus.js';

function TrackingCurrentStatus(_ref) {
  let {
    status,
    statusInfo: _statusInfo,
    ...otherProps
  } = _ref;
  const {
    t
  } = useTranslation();
  return jsxs("div", {
    ...otherProps,
    children: [jsx(Typography, {
      variant: "heading4",
      bold: true,
      component: "div",
      children: t(getTrackingStatusLabelKey(status))
    }), jsx(Typography, {
      css: getTrackingCurrentStatusStyles,
      variant: "body1",
      component: "div",
      children: t(getTrackingStatusDescriptionKey(status))
    })]
  });
}

export { TrackingCurrentStatus };
//# sourceMappingURL=TrackingCurrentStatus.js.map
